import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import DataTable from "../../../../Components/Others/DataTable";
import { Link, useLocation } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import { useFormik } from "formik";
import * as yup from 'yup';
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { NuDate } from "../../../../Components/Utils/Input";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import MultiEditPL from "./MultiEditPL";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import { GetAccess } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";

function PackingListIndex() {

  const location = useLocation();
  const currentPage= location.state?.currentPage
  const searchQuery= location.state?.searchQuery
  const [page, setPage] = useState(currentPage||1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const {value:PackingListStatus} = useFetchMDIndex(`/dropdown/dropdown-details/`,'PackingListStatus',showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    category:"",
    subCategory:""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",

    fromDate:"",
    toDate:"",
    status: ""
  });

  const clearFilter = ()=> {
    setParams({...params,fromDate:"", toDate:"",status:""})
      setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,fromDate:value.fromDate, toDate:value.toDate, status:value.status})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        fromDate: "",
        toDate: "",
        status: ""
      });
    }
  })

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch("/packing-list/", params);

  const defaultHeader = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "DN No. ",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/store/packing-list/view/',
      field: "dnRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Date",
      width: "10%",
      field: "date",
      type:"date",
      textAlign: "center",
      rowAlign: "center",
    },
   
   
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
           contents:{
        // fetcher:getData,
        id:"id",
        removeValue:"companyName",
        url:`/packing-list/`,
        moduleName:'Packing List',
        from:`/store/packing-list/`,
        editLink:'/store/packing-list/edit/',
        viewLink:'/store/packing-list/view/',
        
      }
    },
  ];
  const availableHeaders = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "DN No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/store/packing-list/view/',
      field: "dnRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Date",
      width: "10%",
      field: "date",
      type:"date",
      textAlign: "center",
      rowAlign: "center",
    },
    
    {
      title: "Approved By",
      width: "10%",
      field: "approvedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Verified By",
      width: "10%",
      field: "verifiedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
           contents:{
        // fetcher:getData,
        id:"id",
        removeValue:"companyName",
        url:`/packing-list/`,
        moduleName:'Packing List',
        from:`/store/packing-list/`,
        editLink:'/store/packing-list/edit/',
        viewLink:'/store/packing-list/view/',
        
      }
    },
  ];
  useEffect(()=>{
    setParams({...params,page:page,per_page:pageCount})
   },[page,pageCount])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  

  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) =>{ 
    let NewId;
    if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
      NewId = listofNumbers.filter(Temp=> Temp !== value);
      setListofNumbers(NewId)
    }else{
      setListofNumbers([...listofNumbers,value])
    }
  }

  const selectMultipleFunction = (e) =>{ 
console.log(e.target.checked);
if(e.target.checked){
  setListofNumbers(fullList)
}else{
  setListofNumbers([])
}

  }



  useEffect(()=>{
    let tempArr = []
    data && data.forEach(i=>{
      console.log("I",i?.id);
      tempArr.push(i?.id)
    });
    setFullList(tempArr)
  },[data])
  

  

  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Store",
             
            },
            {
              name: "Packing List",
            },
          ]}
        />
        <div className=" flex gap-2">
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />   <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
          {/* <CreateButton label="Import" /> */}
          {GetAccess("packing_list_create") && <Link to="/store/packing-list/create">
            <CreateButton label="Packing List" />
          </Link>}
        </div>
      </div>

      <CustomDataTable 
      fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight='max-h-[calc(100vh-260px)]'
        height='h-[calc(100vh-145px)]'
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        title='Packing List'
        storageName="PackingListTable"
        selectOneFunction={selectOneFunction}
        setShowDelete={setShowDelete}
        showDelete={showDelete}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        hasMultiEdit={true}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById="id"
        editAccess="packing_list_edit"      
        deteleAccess="packing_list_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}

        />
          {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter Packing-List</h2>
                 <form onSubmit={formik.handleSubmit}> 
                    <div className="flex flex-col mb-4">
                    <p className="py-2 px-6 text-m"> Date</p>
                    <div className="flex justify-between  w-full ">
             <NuDate
              label="From "
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="fromDate"
              width="w-full "
            />
           <NuDate
              label="To "
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="toDate"
              width="w-full "
            />
            </div>
            <FormikSelectTwo
                   type="text"
                   label="Status"
                   placeholder="Status"
                   Options={PackingListStatus}
                   formik={formik}
                   name="status"
                   width="w-full "
                 />
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
            {showEdit && (<MultiEditPL data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)}
        <ModalContainer
                visiable={showDelete}
                title="Warning"
                content={`Are you sure, All selected datas will be removed from YPR List!`}
                handleClick={() =>{}}
                closeModal={() => setShowDelete(false)}
            />
    </div>
  );
}

export default PackingListIndex;
